const initialDispayType = 'with_logo'
const state = { type: initialDispayType }

const getters = {
  isWeb() {
    return state.type == 'with_logo'
  },
  isInAppWeb() {
    return state.type == 'no_logo'
  },
  isSignedInAndAppDisplayType() {
    return state.type == 'coach_list_only'
  },
  displayType() {
    return state.type
  },
}

const mutations = {
  SET(state, displayType) {
    state.type = displayType
  },
}

const actions = {
  setDisplayType({ commit }, displayType) {
    commit('SET', displayType)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
